import { render, staticRenderFns } from "./Bdr2026Table.vue?vue&type=template&id=05495078&scoped=true&"
import script from "./Bdr2026Table.vue?vue&type=script&lang=js&"
export * from "./Bdr2026Table.vue?vue&type=script&lang=js&"
import style0 from "./Bdr2026Table.vue?vue&type=style&index=0&id=05495078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05495078",
  null
  
)

export default component.exports